// extracted by mini-css-extract-plugin
module.exports = {"footer":"footer_footer__ccZ9e","wrapper":"footer_wrapper__1f-I6","ul_footer":"footer_ul_footer__1Ga0_","p_footer":"footer_p_footer__QMv7S"};